export default __webpack_public_path__ + "static/media/typeracer.b0372f15.png";